import { useEffect, useState } from 'react';
import { Socket } from 'socket.io-client';
import { socketClient } from '@/lib/socket-client';

export function useSocket() {
  const [socket, setSocket] = useState<Socket | null>(null);
  const [isConnected, setIsConnected] = useState(false);

  useEffect(() => {
    const sock = socketClient.connect();
    setSocket(sock);

    const handleConnect = () => setIsConnected(true);
    const handleDisconnect = () => setIsConnected(false);

    sock.on('connect', handleConnect);
    sock.on('disconnect', handleDisconnect);

    // Set initial state
    setIsConnected(sock.connected);

    return () => {
      sock.off('connect', handleConnect);
      sock.off('disconnect', handleDisconnect);
    };
  }, []);

  return { socket, isConnected };
}
